import React from "react";
import "./TextCarousel.scss";

function TextCarousel() {
  const words = [
    "Sustainable", "Low MOQ", "Custom Labeling", "Biodegradable", "Recyclable", "Reliable",
    "Cost-Effective", "Upcycled", "Non-Toxic", "Flexible", "Eco-Friendly",
    "Scalable", "Customization", "Zero-Waste", "Regenerative",
    "Fast Delivery", "High-quality production", "Innovative", "Efficient", "Transparent",
    "Compostable", "Plastic-Free", "Organic", "Responsible",
    "Professional", "Lightweight", "Clean", "Reusable", "Ethical"
  ];

  const text = words.map((word, index) => (
    <div key={index} className="carousel-text">{word}</div>
  ));

  return (
    <div className="text-carousel-wrapper">
      <div className="text-carousel" data-text={words.join(" — ")}>
        {text}
        {text /* Duplicate for seamless loop */}
      </div>
    </div>
  );
}

export default TextCarousel;
